<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title mt-0 heading-large">Start Negotiation {{serviceType}}</h1>
                    <button type="button" class="modal-close" data-dismiss="modal" aria-label="Close" @click="closeModal()">
                        <i class="fas fa-lg fa-times"></i>
                    </button>
                </div>
                <div v-if="!showNegotiationPlacedConfirmed">
                    <div v-if="serviceType == '' || ($route.meta.title === eNavbarTitles.negotiations && !serviceTypeSelectionConfirmed)">
                        <div class="modal-body selecting-service-type">
                            <label for="select-service-type">Please select negotiation type</label>
                            <div class="select-wrapper">
                                <select id="select-service-type" v-model="serviceTypeSelected">
                                    <option :value="serviceType" v-for="(serviceType,index) in serviceTypeSelection" :key="index" :disabled="index == 0">
                                        <span v-if="serviceType == -1">Select negotiation type</span>
                                        <span v-else>{{serviceType}}</span>
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-primary float-right" @click="confirmServiceType()" :disabled="serviceTypeSelected == -1">Confirm</button>
                        </div>
                    </div>
                    <div v-else>
                        <div class="modal-body negotiation-selection bg-olf-light-greyish-blue">
                            <div class="row no-gutters">
                                <div class="form-group col-md-6"
                                    :class="{'pr-4' : !$breakpoint.xsOnly}"
                                >
                                    <label :for="[serviceType !== 'Bunkering' ? 'select-fuel-type-nb' : 'select-fuel-type-b']">Product</label>
                                    <div v-if="serviceType !== 'Bunkering'" class="select-wrapper white-field">
                                        <select id="select-fuel-type-nb" v-model="negotiation.fuelType">
                                            <option :value="fuelType._id" v-for="(fuelType,index) in fuelTypeListExrack" :key="index" :disabled="index == 0">
                                                <span v-if="index == 0">Select Product</span>
                                                <span v-else>{{fuelType.name}}</span>
                                            </option>
                                        </select>
                                    </div>
                                    <div v-else class="select-wrapper white-field">
                                        <select id="select-fuel-type-b" v-model="negotiation.fuelType">
                                            <option :value="fuelType._id" v-for="(fuelType,index) in fuelTypeListBunkering" :key="index" :disabled="index == 0">
                                                <span v-if="index == 0">Select Product</span>
                                                <span v-else>{{fuelType.name}}</span>
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="select-measurement">Measurement</label>
                                    <div class="select-wrapper white-field">
                                        <select id="select-measurement" v-model="negotiation.measurement">
                                            <option :value="measurementType" v-for="(measurementType,index) in measurements" :key="index" :disabled="index == 0">
                                                <span v-if="index == 0">Select Measurement</span>
                                                <span v-else>{{measurementType | fuelmeasurementtype}}</span>
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row no-gutters" v-if="serviceType !== 'Bunkering'">
                                <div v-if="serviceType == 'Ex-Rack'" class="form-group col-md-6"
                                    :class="{'pr-4' : !$breakpoint.xsOnly}"
                                >
                                    <label>Terminal</label>
                                    <v-select 
                                        :options="getTerminalChanges" label="name" class="white-field" v-model="negotiation.terminal" placeholder="Search terminal here..." :clearable= "false">
                                    </v-select>
                                </div> 
                                <div class="form-group col-md-6" :class="{'offset-md-6': serviceType !== 'Ex-Rack'}">
                                    <label for="select-collection-period">Lifting Period</label>
                                    <div class="select-wrapper white-field">
                                        <select id="select-collection-period" v-model="negotiation.collectionPeriod">
                                            <option :value="collectionPeriod" v-for="(collectionPeriod,index) in collectionPeriodList" :key="index" :disabled="index == 0">
                                                <span v-if="index == 0">Select Lifting Period</span>
                                                <span v-else>{{collectionPeriod | collectiondaysformat}}</span>
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row no-gutters">
                                <div class="form-group col-md-6"
                                    :class="{'pr-4' : !$breakpoint.xsOnly}"
                                >
                                    <label for="select-negotiation-period">Time Valid</label>
                                    <div class="select-wrapper white-field">
                                        <select id="select-negotiation-period" v-model="negotiation.period">
                                            <option :value="period" v-for="(period,index) in negotiationPeriods" :key="index" :disabled="index == 0">
                                                <span v-if="index == 0">Select Time Valid</span>
                                                <span v-else>{{period | negotiationperiodformat}}</span>
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="select-negotiation-type">Pricing Method</label>
                                    <div class="select-wrapper white-field">
                                        <select id="select-negotiation-type" v-model="negotiation.type">
                                            <option :value="type" v-for="(type,index) in negotiationTypes" :key="index" :disabled="index == 0">
                                                <span v-if="index == 0">Select a Pricing Method</span>
                                                <span v-else>{{type | offertype}}</span>
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-body">
                            <div class="row no-gutters">
                                <div class="form-group col-md-6"
                                    :class="{'pr-4' : !$breakpoint.xsOnly}"
                                >
                                    <label>Your Price (ppl)</label>
                                    <cleave class="form-control" v-model="negotiation.price" 
                                        :options="numeralPositive" @blur.native="setPriceFormat(negotiation.price, 'price')"></cleave>
                                </div>
                                <div class="form-group col-md-6">
                                    <div v-if="negotiation.type == 'TRACKING'">
                                        <label>Max Price (ppl)</label>
                                        <cleave class="form-control" v-model="negotiation.maxPrice" :options="numeralPositive"
                                            @blur.native="setPriceFormat(negotiation.maxPrice, 'max-price')"></cleave>
                                    </div>
                                </div>
                            </div>
                            <div class="row no-gutters">
                                <div class="form-group col-md-6"
                                    :class="{'pr-4' : !$breakpoint.xsOnly}"
                                >
                                    <label>Volume/L</label>
                                    <cleave class="form-control" v-model="negotiation.quantity" 
                                        :options="numeralPositive"></cleave>
                                </div>
                                <div class="form-group col-md-6">
                                    <label>Best Price (ppl)</label>
                                    <input class="form-control" :value="bestPrice > 0 ? bestPrice.toFixed(2) : '0.00' " disabled />
                                </div>
                            </div>
                            <div class="form-group row no-gutters">
                                <template v-if="serviceType !== 'Bunkering'">
                                    <label>Buyer Reference (Optional)</label>
                                    <input class="form-control" v-model="negotiation.reference" />
                                </template>
                                <template v-else>
                                    <label>Keyfuels/UK Fuels account number</label>
                                    <input class="form-control" v-model="negotiation.reference" @keypress="isNumberKeyEvent($event)"/>
                                </template>
                            </div>
                        </div>
                        <div class="modal-body bg-olf-light-greyish-blue">
                            <div class="row">
                                <div class="col-md-6">
                                    TOTAL
                                </div>
                                <div class="col-md-6">
                                    <span class="float-left">
                                        {{negotiation.quantity | volumeformat}} Litres
                                    </span>
                                    <span class="float-right">
                                        £{{negotiation.quantity * negotiation.price/100 | priceformat}}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer d-flex justify-content-between">
                            <span class="error-message float-left">{{error}}</span>
                            <button class="btn btn-primary" @click="confirmNegotiation($event)" :disabled="error || isPlacingNegotiation">
                                <span v-if="isPlacingNegotiation">Processing...</span>
                                <span v-else>Confirm</span>
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Confirmation screen after placing negotiation -->
                <div v-else class="modal-body confirmation text-center mb-5">
                    <h1 class="heading-large">{{placeNegotiationStatusMessage}}</h1>
                    <button class="btn btn-secondary" @click="goToNegotiation()">Go to Negotiation</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import breakpoint from '@/mixins/index';
import { eNavbarTitles } from "@/util/enums/navbar"
import { isNumberKeyEvent } from "@/util/util";
export default {
    mixins: [breakpoint],
    data(){
        return {
            serviceTypeSelection: [-1, 'Ex-Rack', 'Bunkering'],
            serviceTypeSelected: -1,
            serviceTypeSelectionConfirmed: false,
            measurements: [-1, 'STANDARD', 'AMBIENT'],
            collectionPeriodList: [-1, 0, 1, 2, 3, 7, 30],
            negotiationPeriods: [-1, 15, 30, 60, 99],
            negotiationTypes: [-1, 'FIXED', 'TRACKING'],
            negotiation: {
                fuelType: -1,
                measurement: -1,
                terminal: "",
                collectionPeriod: -1,
                period: -1,
                type: -1,
                price: Number(0).toFixed(2),
                maxPrice: Number(0).toFixed(2),
                quantity: 0,
                reference: ''
            },
            isPlacingNegotiation: false,
            eNavbarTitles,
            isNumberKeyEvent,
        }
    },
    created() {
        this.updateShowNegotiationPlacedConfirmation(false)
    },
    computed: {
        ...mapState('allPrices',['activeTabIndex']),
        ...mapState('inputCheckers',['numeralPositive', 'maxExpiryTime']),
        ...mapState('login', ['userLoggedIn']),
        ...mapState('negotiation', ['showNegotiationPlacedConfirmed', 'placeNegotiationStatusMessage', 'negotiationsList']),
        ...mapState('offers', ['liveOffers']),
        ...mapState('terminals',['terminals']),
        ...mapState('selectFavourites',['favouriteOptionSelected','serviceSelectedName']),
        ...mapState('fuelsType', ['fuels']),
        ...mapGetters('negotiation',['getFuelPricesChanges']),
        ...mapGetters('terminals', ['getTerminalChanges']),
        ...mapGetters('metadata', ['productConfig']),
        fuelTypeListExrack: {
            get: function() {
                const selectAFuel = {
                    _id: -1
                }
                let fuelsList = [selectAFuel]
                
                if (this.fuels.length > 0){
                    this.fuels.forEach((fuel, index) => {
                        if (fuel.type == 'SPOT')
                            fuelsList.splice(index + 1, 1, fuel)
                    })
                }
                return fuelsList
            }
        },
        fuelTypeListBunkering: {
            get: function() {
                const selectAFuel = {
                    _id: -1
                }
                let fuelsList = [selectAFuel]
                
                if (this.fuels.length > 0){
                    this.fuels.forEach((fuel, index) => {
                        if (fuel.type == 'BUNKERING')
                            fuelsList.splice(index + 1, 1, fuel)
                    })
                }
                return fuelsList
            }
        },
        serviceType: {
            get: function() {
                const currentRouteTitle = this.$route.meta.title;
                const { dashboard, allPrices, negotiations } = this.eNavbarTitles;
                if (currentRouteTitle === dashboard){
                   return this.serviceSelectedName
                }
                else if (currentRouteTitle === allPrices){
                    switch (this.activeTabIndex){
                        case 0:
                            return 'Ex-Rack'
                        case 1:
                            return 'Bunkering'
                    }
                }
                else if (currentRouteTitle === negotiations){
                    if (this.serviceTypeSelectionConfirmed == false){
                        return ''
                    }
                    else {
                        return this.serviceTypeSelected
                    }
                }
            }
        },
        terminalList: {
            get: function(){
                const selectTerminal = {
                    _id: -1
                }
                return [selectTerminal, ...this.terminals]
            }
        },
        error: {
            get: function(){
                if (this.negotiation.fuelType === -1){
                    return 'Select a product'
                }
                else if (this.negotiation.measurement === -1){
                    return 'Select a fuel measurement'
                }
                else if (this.serviceType === 'Ex-Rack' && (this.negotiation.terminal._id === -1 || !this.negotiation.terminal)){
                    return 'Select a terminal'
                }
                else if (this.serviceType !== 'Bunkering' && this.negotiation.collectionPeriod === -1){
                    return 'Select a collection period'
                }
                else if (this.negotiation.period === -1){
                    return 'Please select how long your negotiation will be valid for'
                }
                else if (this.negotiation.type === -1){
                    return 'Select a pricing method'
                }
                else if (this.negotiation.price <= 0){
                    return 'Enter a valid price'
                }
                else if (this.negotiation.type === 'TRACKING' && Number(this.negotiation.price) > Number(this.negotiation.maxPrice)){
                    return 'Max Price cannot be less than Your Price'
                }
                else if (this.negotiation.quantity <= 0 || !Number.isInteger(Number(this.negotiation.quantity))){
                    return 'Volume must be an integer greater than 0'
                }
                 else if (this.serviceType === 'Bunkering' && this.negotiation.reference === ''){
                    return 'Enter an Account Number'
                }
            }
        },
        trackedPrice: {
            get: function(){
                let fuel = ''
                let price = 0

                if (this.negotiation.type == 'TRACKING'){
                    fuel = this.getFuelPricesChanges.find(fuel => 
                        fuel.fuel_id == this.negotiation.fuelType)

                    /* Let's put an error prevention here: 
                        in case user selects negotiation type as "Tracking" first before selecting any fuel type, 
                        so that we are not returning an error */
                    if (fuel){
                        price = fuel.basePrice
                    }

                    return price
                }
            }
        },
        bestPrice: {
            get: function(){
                let matchingOffersList = []
                let offerPricesList = []
                let lowestPrice = 0

                if (this.negotiation.fuelType !== -1 && this.liveOffers){
                    matchingOffersList = this.liveOffers.filter(offer => {
                        /* Decide whether to check 'SPOT' or 'BUNKERING' offers, then filter the offers list accordingly */
                        if (this.serviceType == 'Ex-Rack'){
                            /* Diesel/Blended Diesel */
                            if (this.negotiation.fuelType == this.productConfig.DieselId){
                                return offer.storage_type_id == 'SPOT' && 
                                    (offer.fuel_id == this.productConfig.DieselId || 
                                    offer.fuel_id == this.productConfig.BlendedDieselBioId) &&
                                    offer.terminal_id == this.negotiation.terminal._id
                            }

                            /* Gasoil/Blended Gasoil */
                            else if (this.negotiation.fuelType == this.productConfig.GasoilId){
                                return offer.storage_type_id == 'SPOT' && 
                                    (offer.fuel_id == this.productConfig.GasoilId || 
                                    offer.fuel_id == this.productConfig.BlendedGasoilId) &&
                                    offer.terminal_id == this.negotiation.terminal._id
                            }

                            /* Kerosene */
                            else {
                                return offer.storage_type_id == 'SPOT' && 
                                    offer.fuel_id == this.negotiation.fuelType && 
                                    offer.terminal_id == this.negotiation.terminal._id
                            }
                        }
                        else {
                            /* UK Fuels */
                            if (this.negotiation.fuelType == this.productConfig.UkFuelsId){
                                return offer.storage_type_id == 'BUNKERING' && offer.network_id == 'UK'
                            }
                            
                            /* Keyfuels */
                            else {
                                return offer.storage_type_id == 'BUNKERING' && offer.network_id == 'KEY'
                            }
                        }
                    })
                    
                    /* Map the prices of each offer in the list */
                    matchingOffersList.forEach(offer => {
                        offerPricesList.push(offer.price)
                    })

                    /* Find the lowest price in the list and return it as 'Best Price' */
                    if (offerPricesList.length > 0){
                        lowestPrice = Math.min(...offerPricesList)
                    }

                    return lowestPrice
                }
            }
        }
    },
    methods: {
        ...mapActions('negotiation',['placeNegotiation', 'updateShowStartNegotiation', 
            'updateShowNegotiationPlacedConfirmation', 'selectNegotiation']),
        ...mapMutations('negotiation', ['SELECT_TAB']),
        setPriceFormat: function(price, element){
            if (element == 'max-price'){
                this.negotiation.maxPrice = Number(price).toFixed(2)
            }
            else {
                this.negotiation.price = Number(price).toFixed(2)
            }
        },
        confirmServiceType: function(){
            this.serviceTypeSelectionConfirmed = true
        },
        confirmNegotiation: async function(event){
            this.isPlacingNegotiation = true
            const moment = require('moment')
            
            let negotiation = {
                userId: this.userLoggedIn.userId,
                fuel_id: this.negotiation.fuelType,
                quantity: Number(this.negotiation.quantity),
                price: this.negotiation.type == 'FIXED' ? 
                    Number(this.negotiation.price) : (Number(this.negotiation.price) - Number(this.trackedPrice)),
                maxPrice: this.negotiation.type == 'FIXED' ? Number(this.negotiation.price) : Number(this.negotiation.maxPrice),
                terminal_id: this.serviceType == 'Ex-Rack' ? this.negotiation.terminal._id : null,
                fuel_measurement_id: this.negotiation.measurement,
                collectionTime: this.negotiation.collectionPeriod,
                type_id: this.negotiation.type,
                reference: this.negotiation.reference,
                periodId: this.negotiation.period == 99 || (this.negotiation.period !== 99 &&
                    new Date(moment().add(this.negotiation.period, 'minutes').toDate()) > new Date(this.maxExpiryTime))?
                    'EOD' : this.negotiation.period + 'M'
            }
            
            const negotiationPlaced = await this.placeNegotiation(negotiation)
        },
        closeModal: function(){
            const negotiation = {
                fuelType: -1,
                measurement: -1,
                terminal: -1,
                collectionPeriod: -1,
                period: -1,
                type: -1,
                price: 0,
                quantity: 0,
                reference: ''
            }
            this.negotiation = negotiation

            if (this.$route.meta.title === this.eNavbarTitles.negotiations){
                this.serviceTypeSelected = -1
                this.serviceTypeSelectionConfirmed = false
            }

            $(this.$el).modal('hide')
            this.updateShowNegotiationPlacedConfirmation(false)
            this.updateShowStartNegotiation(false)
        },
        goToNegotiation: function(){
            const negotiations = Object.assign([], this.negotiationsList)
            let sortedNegotiationListByCreatedTime = negotiations.sort((a, b) => {
                return new Date(a.created) - new Date(b.created)
            })

            const newNegotiation = sortedNegotiationListByCreatedTime[sortedNegotiationListByCreatedTime.length - 1]

            /* Go to the page */
            this.$router.push({name: 'NegotiationsBuyer'})

            /* Select the negotiation */
            this.selectNegotiation(newNegotiation._id)
            this.SELECT_TAB(0)
            this.closeModal()
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/components/_modals.scss";
</style>